import { PATHS } from "src/routes/paths";


export const getPathAfterLogin = (role) => {
  switch (role) {
    case "hotel":
      return PATHS.hotel.root;
    case "shop":
      return PATHS.shop.root;
    case "voucherAdmin":
      return PATHS.voucherAdmin.root;
    default:
      return PATHS.listings.list;
  }
};